import SuratJalanApi from "./SuratJalanApi"

export default SuratJalanApi